/** Default Web Speech settings for Peppy AI. */

export const CAPTAIN_SPEECH_LANG = 'en-IN';
export const CAPTAIN_SPEECH_RATE = 0.9;
export const CAPTAIN_SPEECH_PITCH = 1.0;
export const CAPTAIN_SPEECH_VOLUME = 1.0;

let cachedVoiceUri: string | null = null;

function normalizeLang(lang: string): string {
  return lang.trim().toLowerCase().replace('_', '-');
}

function dedupeVoices(voices: SpeechSynthesisVoice[]): SpeechSynthesisVoice[] {
  const seen = new Set<string>();
  const out: SpeechSynthesisVoice[] = [];
  for (const voice of voices) {
    const key = voice.voiceURI || `${voice.name}:${voice.lang}`;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(voice);
  }
  return out;
}

/** Prefer the first available Indian English voice (en-IN). */
export function pickCaptainSpeechVoice(
  voices: SpeechSynthesisVoice[]
): SpeechSynthesisVoice | undefined {
  const list = dedupeVoices(voices);
  if (!list.length) return undefined;

  if (cachedVoiceUri) {
    const cached = list.find((v) => v.voiceURI === cachedVoiceUri);
    if (cached) return cached;
    cachedVoiceUri = null;
  }

  const voice = list.find((v) => normalizeLang(v.lang) === 'en-in');
  if (voice) {
    cachedVoiceUri = voice.voiceURI;
  }
  return voice;
}

export function resetCaptainSpeechVoiceCache(): void {
  cachedVoiceUri = null;
}

export function applyCaptainSpeechUtterance(
  utterance: SpeechSynthesisUtterance,
  voice?: SpeechSynthesisVoice
): void {
  utterance.rate = CAPTAIN_SPEECH_RATE;
  utterance.pitch = CAPTAIN_SPEECH_PITCH;
  utterance.volume = CAPTAIN_SPEECH_VOLUME;
  utterance.lang = CAPTAIN_SPEECH_LANG;

  if (voice) {
    utterance.voice = voice;
  }
}

export function getCaptainSpeechVoices(): SpeechSynthesisVoice[] {
  if (typeof window === 'undefined' || !window.speechSynthesis) return [];
  return dedupeVoices(window.speechSynthesis.getVoices());
}
